export default "__VITE_ASSET__c8cc96af__"